<div class="layout-col full">
  <mat-tab-group class="full" elderTabGroupRouting="evaluation" animationDuration="0ms">
    <mat-tab [label]="'reports.productivity' | translate" elderTab="productivity">
      <ng-template matTabContent>
        <elder-basic-pane-layout class="full">
          <elder-pane>
            <app-productivity-report-table class="flex"></app-productivity-report-table>
          </elder-pane>
        </elder-basic-pane-layout>
      </ng-template>
    </mat-tab>

    <mat-tab [label]="'reports.productionPerWorkCenter' | translate" elderTab="workCenter">
      <ng-template matTabContent>
        <elder-basic-pane-layout class="full">
          <elder-pane>
            <app-utilization-report-table class="flex"> </app-utilization-report-table>
          </elder-pane>
        </elder-basic-pane-layout>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
